import React from 'react'
import './Text.less'

const Text = ({ children, type }) => <div className={`marley-text ${type ? `marley-text-${type}` : ''}`}>{children}</div>

export default Text